import script from "./PartnerAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./PartnerAdd.vue?vue&type=script&setup=true&lang=js"

import "@/assets/css/pc/account.css?vue&type=style&index=0&id=64903858&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64903858"]])

export default __exports__